// Budget demo · money formatting helpers.

import { Money } from "./types";

const SYMBOL: Record<Money["currency"], string> = {
    USD: "$",
    EUR: "€",
    GBP: "£",
};

/** Exact dollars with thousands separators: "$1,284,500". */
export function formatMoney(m: Money): string {
    return `${SYMBOL[m.currency]}${Math.round(m.amount).toLocaleString()}`;
}

/** Compact for headlines: "$30.4M", "$812K", "$640". Always rounds sensibly. */
export function formatCompact(m: Money): string {
    const sym = SYMBOL[m.currency];
    const sign = m.amount < 0 ? "-" : "";
    const abs = Math.abs(m.amount);
    if (abs >= 1_000_000) return `${sign}${sym}${(abs / 1_000_000).toFixed(1)}M`;
    if (abs >= 1_000) return `${sign}${sym}${Math.round(abs / 1_000)}K`;
    return `${sign}${sym}${Math.round(abs)}`;
}

/** Signed compact for deltas: "+$1.2M", "-$340K", "$0". */
export function formatSignedCompact(m: Money): string {
    if (Math.round(m.amount) === 0) return `${SYMBOL[m.currency]}0`;
    const body = formatCompact({ ...m, amount: Math.abs(m.amount) });
    return `${m.amount < 0 ? "-" : "+"}${body}`;
}

/** Percent from a fraction: 0.043 → "+4.3%". */
export function formatPct(fraction: number, withSign = true): string {
    const pct = fraction * 100;
    const sign = withSign && pct > 0 ? "+" : "";
    return `${sign}${pct.toFixed(1)}%`;
}
